export default function SectionEyebrow({ children, dark = false }) {
  return (
    <div
      className={`bsca-eyebrow ${dark ? "text-[#D4AF37]" : "text-[#7A5A06]"} mb-4 flex items-center gap-3`}
    >
      <span className="inline-block h-px w-8 bg-current opacity-60" />
      <span>{children}</span>
    </div>
  );
}
